import "normalize.css"
import { withPrefix } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"
import ekomi from "../../images/siegel_ekomi.png"
import tuev from "../../images/TUEV.svg"
import { NotPhone, onPhone } from "../../theme/MediaQueries"
import Footer from "../footer"
import Header from "../header"
import { Container, HorizontalLine, LimitedWidth } from "./styles"

const ContentContainer = styled.div`
  background-image: url(${withPrefix('/Image1680_03@1.jpg')});
  background-repeat: no-repeat;
  background-color: #faf9fe;
  padding: 10px 0;
  ${onPhone} {
    padding: 0;
  }
`

const TrustContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
`

const StyledImage = styled.img`
  margin: 0;
  height: 48px;
  padding: 0 8px;
`

const Layout = ({ children, style = {}, ...props }) => {
  return (
    <Container>
      <div>
        <LimitedWidth>
          <Header>
            <NotPhone>
              <TrustContainer>
                <a target="_blank" rel="noopener noreferrer" href="https://www.ekomi.de/bewertungen-finanzcheck.html">
                  <StyledImage src={ekomi} />
                </a>
                <a target="_blank" rel="noopener noreferrer" href="https://www.tuev-saar.de/zertifikat/tk43790/">
                  <StyledImage src={tuev} />
                </a>
              </TrustContainer>
            </NotPhone>
          </Header>
        </LimitedWidth>
        <HorizontalLine />

        <ContentContainer>
          <LimitedWidth value="745px">
            <main>{children}</main>
          </LimitedWidth>
        </ContentContainer>
      </div>
      <div>
        <HorizontalLine />
        <LimitedWidth>
          <Footer />
        </LimitedWidth>
      </div>
    </Container>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
